import React from 'react';
import QuotaAdjustmentContainer from '../../../containers/credits/quotaAdjustment';

const QuotaAdjustmentPage: React.FC = () => {
  return <QuotaAdjustmentContainer />;
};

export default QuotaAdjustmentPage;
